<template>
  <div class="receipt-detail-drawer">
    <finance-drawer
      title="补款申请详情"
      width="70%"
      v-bind="$attrs"
      v-on="$listeners"
      :title-no="suppleApplyNo"
      :modal-close="false"
      @open="handleOpen"
      @refresh="handleOpen"
    >
      <div slot="drawer-operation">
        <btns-operate :current="detailInfo" @success="init" :show="['WAIT'].includes(detailInfo.approvalStatus)" />
      </div>
      <div class="main-cont" v-loading="loading">
        <div class="main-cont-item">
          <h2 class="title-text">
            基础信息
            <icon-status
              :color="statusColorFilters(detailInfo.approvalStatus)"
              :status="detailInfo.approvalStatusDesc"
            />
          </h2>
          <el-row :gutter="20" style="margin-top: -8px;">
            <jr-col :data-show="firstCol" :data="detailInfo" />
            <jr-col :data-show="secondCol" :data="detailInfo" />
            <jr-col :data-show="thirdCol" :data="detailInfo" />
          </el-row>
          <el-row>
            <data-show label="补款原因:">
              <div>{{detailInfo.suppleReason || '-'}}</div>
            </data-show>
          </el-row>
          <el-row v-if="['REJECT'].includes(detailInfo.approvalStatus)">
            <data-show label="驳回原因:">
              <div>{{detailInfo.rejectReason || '-'}}</div>
            </data-show>
          </el-row>
        </div>
        <div class="main-cont-item" v-if="detailInfo.supplementInfos && detailInfo.supplementInfos.length">
          <h2 class="title-text">补款到账信息</h2>
          <info-tree :list="detailInfo.supplementInfos" :amount="detailInfo.suppleAmount" />
        </div>
        <div class="main-cont-item">
          <h2 class="title-text">补款凭证</h2>
          <div>
            <div v-if="!detailInfo.certificate" class="no-certificate">无凭证</div>
            <jr-preview-image v-else :image-list="$stringToArray(detailInfo.certificate)|| []" :is-own="true" />
          </div>
        </div>
        <div class="main-cont-item">
          <h2 class="title-text">原交易单信息</h2>
          <jr-table
            :size="formSize"
            :tableData="infoList"
            :tableColumn="tableColumn"
          />
        </div>
        <div class="main-cont-item">
          <h2 class="title-text">补款记录</h2>
          <jr-table
            :size="formSize"
            :tableData="detailInfo.supplementRecords"
            :tableColumn="supplementRecordsTableColumn"
          />
        </div>
      </div>
    </finance-drawer>
  </div>
</template>
<script>
import { getApplyDetail } from '@/api/supplement';
import btnsOperate from './btns-operate';
import { setStatusColor } from '@/filters/index';
import infoTree from './info-tree';

export default {
  props: {
    suppleApplyNo: {
      type: String,
      default: '',
    },
    amount: {
      type: [Number, String],
      default: 0,
    },
  },
  components: { btnsOperate, infoTree },
  data() {
    return {
      detailInfo: {},
      loading: false,
      // 基础信息
      firstCol: [
        { label: '补款申请编号:', prop: 'suppleApplyNo' },
        { label: '业务订单号:', prop: 'origTransNum' },
        { label: '客户编号:', prop: 'businessNo' },
        { label: '客户名称:', prop: 'businessName' },
      ],
      secondCol: [
        { label: '申请补款金额:', prop: 'suppleAmount', filters: 'toFenThousandsAndFloat(¥)' },
        { label: '订单已补总额:', prop: 'suppledAmount', filters: 'toFenThousandsAndFloat(¥)' },
        { label: '订单实付金额:', prop: 'realAmount', filters: 'toFenThousandsAndFloat(¥)' },
        { label: '订单应付金额:', prop: 'shouldAmount', filters: 'toFenThousandsAndFloat(¥)' },
      ],
      thirdCol: [
        { label: '申请时间:', prop: 'createTime', filters: 'formatTime' },
        { label: '申请人:', prop: 'createUser' },
        { label: '操作时间:', prop: 'modifyTime', filters: 'formatTime' },
        { label: '操作人:', prop: 'modifyUser' },
      ],
      tableColumn: [
        { label: '业务订单号', prop: 'origTransNum' },
        { label: '应付金额(元)', prop: 'shouldAmount', filterName: 'toFenThousandsAndFloat' },
        { label: '实付金额(元)', prop: 'realAmount', filterName: 'toFenThousandsAndFloat' },
        { label: '订单已补总额(元)', prop: 'suppledAmount', filterName: 'toFenThousandsAndFloat' },
      ],
      supplementRecordsTableColumn: [
        { label: '补款单编号', prop: 'suppleOrderNo' },
        { label: '创建时间', prop: 'createTime', filterName: 'formatTime' },
        { label: '补款方式', prop: 'suppleWayDesc' },
        { label: '补款渠道', prop: 'suppleChannelDesc' },
        { label: '补款金额(元)', prop: 'suppleAmount', filterName: 'toFenThousandsAndFloat' },
        {
          label: '状态',
          status: 'suppleStatus',
          statusDesc: 'suppleStatusDesc',
          statusColor: (val) => setStatusColor(val, 'cancelStatus'),
        },
        { label: '完成时间', prop: 'thirdFinishTime', filterName: 'formatTime' },
      ],
      infoList: [],
    };
  },
  watch: {
    suppleApplyNo: {
      deep: true,
      handler() {
        if (this.suppleApplyNo) {
          this.handleOpen();
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 打开窗口前
    handleOpen() {
      this.detailInfo = {};
      this.infoList = [];
      this.$nextTick(() => {
        this.init();
      });
    },
    init() {
      this.getApplyDetail();
    },
    statusColorFilters(status) {
      return setStatusColor(status, 'approvalStatus');
    },
    // 获取详情接口
    async getApplyDetail() {
      try {
        this.loading = true;
        const res = await getApplyDetail({ suppleApplyNo: this.suppleApplyNo });
        const { data = {} } = res;
        this.detailInfo = data || {};
        this.infoList = [
          {
            origTransNum: data.origTransNum || '',
            shouldAmount: data.shouldAmount ?? '',
            realAmount: data.realAmount ?? '',
            suppledAmount: data.suppledAmount ?? '',
          },
        ];
      } catch (error) {
        console.log(error);
        this.detailInfo = {};
        this.infoList = [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
